export default {
  stringify(payload, jsonStringify) {
    const variables = {}
    if (payload) {
      payload.forEach((item) => {
        try {
          const obj = { name: item[0], value: item[1], type: item[2] }
          if (obj.type === 'Date' && obj.value) {
            obj.value = obj.value.toISOString()
          } else if (obj.type === 'Json' && obj.value) {
            obj.value = JSON.stringify(obj.value)
          }
          variables[obj.name] = { value: obj.value, type: obj.type }
        } catch (error) {
          console.error(error)
        }
      })
    }
    return jsonStringify ? JSON.stringify(variables) : variables
  },

  parse(payload, jsonParse) {
    const variables = jsonParse ? JSON.parse(payload) : payload
    if (variables) {
      Object.keys(variables).forEach((key) => {
        try {
          const obj = variables[key]
          if (obj.type === 'Date' && obj.value) {
            obj.value = new Date(obj.value)
          } else if (obj.type === 'Json' && obj.value) {
            obj.value = JSON.parse(obj.value)
          }
        } catch (error) {
          console.error(error)
        }
      })
    }
    return variables
  },

  parseHistory(payload) {
    const variables = {}
    if (payload) {
      payload.forEach((item) => {
        let value = item.value
        try {
          if (item.type === 'Date' && item.value) {
            value = new Date(item.value)
          } else if (item.type === 'Json' && item.value) {
            value = JSON.parse(item.value)
          }
          variables[item.name] = {
            type: item.type,
            value: value,
          }
        } catch (error) {
          console.error(error)
        }
      })
    }
    return variables
  },
}



// WEBPACK FOOTER //
// ./src/utils/variablesProcessing.js